module.exports = __webpack_public_path__ + "img/leiria.c871c220.jpg";